/**
 * 工作台仪表盘（与订单/随心订/商品数据对齐）
 * @param {object} params { range?: 'today'|'week'|'month'|'custom', start?, end? ISO 字符串 }
 */
export function fetchDashboard(api, params = {}) {
  return api.get('/admin/dashboard', { params })
}
